import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

import {
  brandsRangesAllSelectedSelector,
  brandsRangesSearchFiltersSelector,
  brandsRangesSearchOptionsSelector,
  brandsRangesSelectedFiltersSelector,
  brandsRangesState,
  hasSelectedBrandsRangesSelector,
  headerBrandState,
  resetBrandsRangesSelector,
  selectBrandSelector,
  selectRangeSelector,
  toggleBrandRangeSelector,
} from '@/states/filters/brands-ranges.state';

export function useBrandsRangesFilter() {
  const [brandsRangesFilter, setBrandsRangesFilter] =
    useRecoilState(brandsRangesState);
  const [headerBrand, setHeaderBrands] = useRecoilState(headerBrandState);
  const { brandsRangesSearchFilters } = useRecoilValue(
    brandsRangesSearchFiltersSelector,
  );
  const { brandsRangesSelectedFilters } = useRecoilValue(
    brandsRangesSelectedFiltersSelector,
  );
  const brandsRangesSearchOptions = useRecoilValue(
    brandsRangesSearchOptionsSelector,
  );
  const { brandsRangesAllSelected } = useRecoilValue(
    brandsRangesAllSelectedSelector,
  );
  const hasSelectedBrandsRanges = useRecoilValue(
    hasSelectedBrandsRangesSelector,
  );
  const resetBrandsRanges = useSetRecoilState(resetBrandsRangesSelector);
  const selectBrand = useSetRecoilState(selectBrandSelector);
  const selectRange = useSetRecoilState(selectRangeSelector);
  const toggleBrandRange = useSetRecoilState(toggleBrandRangeSelector);

  return {
    brandsRangesFilter,
    setBrandsRangesFilter,
    brandsRangesSearchFilters,
    brandsRangesSelectedFilters,
    brandsRangesSearchOptions,
    brandsRangesAllSelected,
    hasSelectedBrandsRanges,
    resetBrandsRanges,
    selectBrand,
    selectRange,
    toggleBrandRange,
    headerBrand,
    setHeaderBrands,
  };
}
